module.exports = __webpack_public_path__ + "static/media/icon_restoration_pontic_1.7b59f976.svg";